import * as React from 'react';
import { ProgressView } from '../ProgressView';
import { UserState } from 'app/reducers/state';
import { Tabs, Tab } from '@blueprintjs/core';

interface Props {
    user: UserState;
    classID: string;
};

interface State {}

export class ProgressTabs extends React.Component<Props, State> {

    state: State = {

    }

	render() {
        return <Tabs
            animate={true}
            id="progress_view_tabs"
            key={"horizontal"}
            renderActiveTabPanelOnly={false}
            vertical={false}
        >
            <Tab id="progressview_scenario_1" title="Module 2" panel={<ProgressView scenario="scenario_1" classID={this.props.classID} user={this.props.user} />} />
            <Tab id="progressview_scenario_2" title="Module 3" panel={<ProgressView scenario="scenario_2" classID={this.props.classID} user={this.props.user} />} />
            <Tab id="progressview_scenario_3" title="Module 4" panel={<ProgressView scenario="scenario_3" classID={this.props.classID} user={this.props.user} />} />
        </Tabs>
	}
}
